// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SavedMapView-module__savedMapContainer___U0nbM {
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100%;
}

.SavedMapView-module__mapHeader___GxqVS {
    background-color: black;
    color: white;
    padding: 16px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100px;
}

    .SavedMapView-module__mapHeader___GxqVS h2 {
        margin: 0;
        font-size: 2rem;
    }

.SavedMapView-module__mapInfo___iP3Ra {
    color: #e5e7eb;
    font-size: 1.5rem;
}

.SavedMapView-module__backButton___ljghq {
    background-color: var(--bmo-primary-color-mint);
    color: white;
    padding: 10px 15px;
    border: none;
    border-radius: 8px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

    .SavedMapView-module__backButton___ljghq:hover {
        background-color: var(--bmo-primary-color-mint-dark);
    }

.SavedMapView-module__mapWrapper___yMMbT {
    flex: 1;
    position: relative;
}

.SavedMapView-module__errorContainer___rZ4eo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    text-align: center;
    padding: 0 20px;
    background-color: #f3f4f6;
}

    .SavedMapView-module__errorContainer___rZ4eo h2 {
        color: #111827;
        margin-bottom: 12px;
        font-size: 1.5rem;
    }

    .SavedMapView-module__errorContainer___rZ4eo p {
        color: #6b7280;
        margin-bottom: 24px;
        max-width: 500px;
    }
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/Map/SavedMapView.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;AACjB;;IAEI;QACI,SAAS;QACT,eAAe;IACnB;;AAEJ;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,+CAA+C;IAC/C,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,sCAAsC;AAC1C;;IAEI;QACI,oDAAoD;IACxD;;AAEJ;IACI,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;IAEI;QACI,cAAc;QACd,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,mBAAmB;QACnB,gBAAgB;IACpB","sourcesContent":[".savedMapContainer {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    width: 100%;\n}\n\n.mapHeader {\n    background-color: black;\n    color: white;\n    padding: 16px 24px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 100px;\n}\n\n    .mapHeader h2 {\n        margin: 0;\n        font-size: 2rem;\n    }\n\n.mapInfo {\n    color: #e5e7eb;\n    font-size: 1.5rem;\n}\n\n.backButton {\n    background-color: var(--bmo-primary-color-mint);\n    color: white;\n    padding: 10px 15px;\n    border: none;\n    border-radius: 8px;\n    font-weight: bold;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n    .backButton:hover {\n        background-color: var(--bmo-primary-color-mint-dark);\n    }\n\n.mapWrapper {\n    flex: 1;\n    position: relative;\n}\n\n.errorContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n    text-align: center;\n    padding: 0 20px;\n    background-color: #f3f4f6;\n}\n\n    .errorContainer h2 {\n        color: #111827;\n        margin-bottom: 12px;\n        font-size: 1.5rem;\n    }\n\n    .errorContainer p {\n        color: #6b7280;\n        margin-bottom: 24px;\n        max-width: 500px;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"savedMapContainer": `SavedMapView-module__savedMapContainer___U0nbM`,
	"mapHeader": `SavedMapView-module__mapHeader___GxqVS`,
	"mapInfo": `SavedMapView-module__mapInfo___iP3Ra`,
	"backButton": `SavedMapView-module__backButton___ljghq`,
	"mapWrapper": `SavedMapView-module__mapWrapper___yMMbT`,
	"errorContainer": `SavedMapView-module__errorContainer___rZ4eo`
};
export default ___CSS_LOADER_EXPORT___;
